<template>
    <section
        id="services"
        class="services-section"
    >
        <div class="section-container">

            <div class="section-header">

                <span class="section-index">
                    {{ 'home_services' | staticContentAlt }}
                </span>

                <h2 class="section-title">
                    {{ 'home_services' | staticTitle }}
                </h2>

                <p class="section-intro">
                    {{ 'home_services' | staticContent }}
                </p>

            </div>

            <div class="services-list">

                <article
                    v-for="service in services"
                    :key="service.hash"
                    class="service-card"
                >
                    <span class="service-number">
                        {{ service.hash | staticContentAlt }}
                    </span>

                    <div class="service-card__content">

                        <h3>
                            {{ service.hash | staticTitle }}
                        </h3>

                        <p>
                            {{ service.hash | staticContent }}
                        </p>

                    </div>

                    <span class="service-card__arrow">
                        ↗
                    </span>

                </article>

            </div>

        </div>
    </section>
</template>

<script>
export default {
    name: 'HomeServices',

    data() {
        return {
            services: [
                {
                    hash: 'home_service_web'
                },
                {
                    hash: 'home_service_mobile'
                },
                {
                    hash: 'home_service_software'
                },
                {
                    hash: 'home_service_ecommerce'
                }
            ]
        };
    }
};
</script>

<style lang="scss" scoped>
.services-section {
    position: relative;

    padding: 6.25em 0;

    background:
        radial-gradient(
            circle at 18% 20%,
            rgba(233, 81, 29, .06),
            transparent 28%
        ),
        radial-gradient(
            circle at 82% 78%,
            rgba(35, 83, 150, .10),
            transparent 32%
        ),
        var(--color-1);

    overflow: hidden;
}

.services-section::before {
    content: "";

    position: absolute;

    top: 0;
    left: 50%;

    width: 0.0625em;
    height: 6.25em;

    background:
        linear-gradient(
            180deg,
            rgba(233, 81, 29, 0),
            rgba(233, 81, 29, .55),
            rgba(233, 81, 29, 0)
        );

    opacity: .55;
}

.section-container {
    position: relative;

    width: 100%;
    max-width: 84.375em;

    margin: 0 auto;

    padding: 0 1.25em;

    z-index: 2;
}

.section-header {
    margin-bottom: 3.4375em;
}

.section-index {
    display: flex;
    align-items: center;

    gap: 0.875em;

    margin-bottom: 1.375em;

    color: var(--text-3);

    font-family: var(--font-tech);
    font-size: 0.75em;
    -letter-spacing: 0.1875em;
}

.section-index::before {
    content: "";

    width: 2em;
    height: 0.0625em;

    background: var(--color-3);

    box-shadow:
        0 0 0.75em
        rgba(233, 81, 29, .4);
}

.section-title {
    max-width: 51.25em;

    margin: 0;

    color: var(--text-1);

    font-size: clamp(2.75em, 10vw, 5.25em);
    font-weight: 700;
    line-height: .92;
    -letter-spacing: -0.1875em;

    text-transform: uppercase;
}

.section-intro {
    max-width: 26.875em;

    margin-top: 1.5em;

    color: var(--text-2);

    font-size: 0.875em;
    line-height: 1.7;
}

.services-list {
    display: grid;
    grid-template-columns: 1fr;

    gap: 1em;
}

.service-card {
    position: relative;

    display: grid;
    grid-template-columns: 2.625em 1fr;

    gap: 1.125em;

    min-height: 10.9375em;

    padding: 1.75em;

    border: 0.0625em solid var(--border-1);
    border-radius: 1em;

    background:
        linear-gradient(
            145deg,
            rgba(255, 255, 255, .025),
            rgba(255, 255, 255, .006)
        );

    overflow: hidden;

    transition:
        transform .35s ease,
        border-color .35s ease,
        background .35s ease,
        box-shadow .35s ease;
}

.service-card::before {
    content: "";

    position: absolute;

    inset: 0;

    background:
        linear-gradient(
            120deg,
            rgba(233, 81, 29, .09),
            rgba(233, 81, 29, .018) 38%,
            transparent 75%
        );

    opacity: 0;

    transition: opacity .35s ease;

    pointer-events: none;
}

.service-card::after {
    content: "";

    position: absolute;

    left: 0;
    top: 22%;

    width: 0.1875em;
    height: 0;

    background: var(--color-3);

    box-shadow:
        0 0 1em
        rgba(233, 81, 29, .55);

    transition: height .35s ease;
}

.service-number {
    position: relative;

    z-index: 2;

    padding-top: 0.1875em;

    color: var(--text-3);

    font-family: var(--font-tech);
    font-size: 0.75em;
    -letter-spacing: 0.125em;
}

.service-card__content {
    position: relative;

    z-index: 2;

    padding-right: 2.125em;

    h3 {
        margin: 0 0 0.75em;

        color: var(--text-1);

        font-family: var(--font-tech);
        font-size: 0.875em;
        font-weight: 600;
        -letter-spacing: 0.125em;

        text-transform: uppercase;

        transition:
            color .35s ease,
            transform .35s ease;
    }

    p {
        max-width: 26.25em;

        margin: 0;

        color: var(--text-2);

        font-size: 0.8125em;
        line-height: 1.65;

        transition:
            color .35s ease,
            transform .35s ease;
    }
}

.service-card__arrow {
    position: absolute;

    top: 1.5em;
    right: 1.5em;

    z-index: 2;

    display: flex;
    justify-content: center;
    align-items: center;

    width: 2em;
    height: 2em;

    border: 0.0625em solid rgba(233, 81, 29, .25);
    border-radius: 50%;

    color: var(--text-3);

    font-size: 0.9375em;

    transition:
        transform .35s ease,
        background .35s ease,
        border-color .35s ease,
        color .35s ease,
        box-shadow .35s ease;
}

.service-card:hover {
    transform: translateY(-0.3125em);

    border-color:
        rgba(233, 81, 29, .38);

    background:
        linear-gradient(
            145deg,
            rgba(233, 81, 29, .065),
            rgba(255, 255, 255, .008)
        );

    box-shadow:
        0 1.375em 2.8125em
        rgba(0, 0, 0, .18);
}

.service-card:hover::before {
    opacity: 1;
}

.service-card:hover::after {
    height: 56%;
}

.service-card:hover .service-card__content h3 {
    color: var(--text-3);

    transform: translateX(0.25em);
}

.service-card:hover .service-card__content p {
    color: #B8B8B8;

    transform: translateX(0.25em);
}

.service-card:hover .service-card__arrow {
    transform:
        translate(0.1875em, -0.1875em)
        rotate(45deg);

    color: var(--text-1);

    border-color: var(--color-3);

    background:
        rgba(233, 81, 29, .12);

    box-shadow:
        0 0 1.125em
        rgba(233, 81, 29, .18);
}

@media (min-width: 48em) {
    .services-section {
        padding: 7.5em 0;
    }

    .section-container {
        padding: 0 2.5em;
    }

    .section-header {
        margin-bottom: 4.0625em;
    }

    .services-list {
        gap: 1.125em;
    }

    .service-card {
        min-height: 11.875em;

        padding: 2em;
    }

    .service-card__content {
        h3 {
            font-size: 0.9375em;
        }

        p {
            font-size: 0.875em;
        }
    }
}

@media (min-width: 56.25em) {
    .services-list {
        grid-template-columns:
            repeat(2, 1fr);
    }

    .service-card {
        min-height: 12.8125em;
    }
}

@media (min-width: 75em) {
    .services-section {
        padding: 8.4375em 0;
    }

    .section-container {
        padding: 0 3.75em;
    }

    .section-title {
        font-size: 5.75em;
    }

    .services-list {
        gap: 1.25em;
    }

    .service-card {
        min-height: 13.4375em;

        padding: 2.25em;
    }
}
</style>